"use client"
import ImageLightboxGrid from '@/ui/ImageLightBoxgrid'
import React from 'react'
import img1 from "@/assets/happyfaces/02.jpg";
import img2 from "@/assets/happyfaces/04.jpg";
import img3 from "@/assets/happyfaces/05.jpg";
import img4 from "@/assets/happyfaces/06.jpg";
import img6 from "@/assets/happyfaces/07.jpg";
import img8 from "@/assets/happyfaces/08.jpg";
import img10 from "@/assets/happyfaces/09.jpg";
import img11 from "@/assets/happyfaces/10.jpg";
import large1 from "@/assets/happyfaces/face-large-1.jpg";
import large2 from "@/assets/happyfaces/face-large-2.jpg";
import Partnership from '../hostel/Patnership';
import CampusGallery from '@/ui/Campusgallery';


const HappyfaceImages = () => {
    const Happyfaces = [
        { src: img1, alt: "happy faces 1" },
        { src: img2, alt: "happy faces 2" },
        { src: img3, alt: "happy faces 3" },
        { src: img4, alt: "happy faces 4" },
        { src: img6, alt: "happy faces 6" },
        { src: img8, alt: "happy faces 8" },
        { src: img10, alt: "happy faces 10" },
        { src: img11, alt: "happy faces 11" },
        { src: large1, alt: "happy faces large 1" },
        { src: large2, alt: "happy faces large 2" },
    ]


    return (
        <div>
            <CampusGallery
                mainLeftImages={[
                    { src: img1, alt: "happy faces 1" },
                    { src: img2, alt: "happy faces 2" },
                    { src: img3, alt: "happy faces 3" },
                    { src: img4, alt: "happy faces 4" },
                    { src: img6, alt: "happy faces 6" },
                    { src: img8, alt: "happy faces 8" },
                ]}
                mainRightImage={{ src: large1, alt: "happy faces large 1" }}
                gridImages={[
                    { src: img1, alt: "happy faces 1" },
                    { src: img2, alt: "happy faces 2" },
                    { src: img3, alt: "happy faces 3" },
                    { src: img4, alt: "happy faces 4" },
                    { src: img6, alt: "happy faces 6" },
                    { src: img8, alt: "happy faces 8" },
                    { src: img10, alt: "happy faces 10" },
                    { src: img11, alt: "happy faces 11" },
                    { src: large1, alt: "happy faces large 1" },
                    { src: large2, alt: "happy faces large 2" },
                    { src: img11, alt: "happy faces 11" },
                    { src: large2, alt: "happy faces large 2" },
                ]}
            />
            {/* <Partnership /> */}
        </div>
    )
}

export default HappyfaceImages